type DeploymentType = "internal" | "external";

export const getDeploymentType = (): DeploymentType => {
	const rawType = import.meta.env["VITE_DEPLOYMENT_TYPE"] as string | undefined;
	const type = rawType?.trim();
	return type === "internal" || type === "external" ? type : "external";
};

export const getIsInternal = (): boolean => {
	return getDeploymentType() === "internal";
};
